import { render, staticRenderFns } from "./LookVideo.vue?vue&type=template&id=ed8f3fec&scoped=true&"
import script from "./LookVideo.vue?vue&type=script&lang=js&"
export * from "./LookVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8f3fec",
  null
  
)

export default component.exports